module.exports = __webpack_public_path__ + "img/default-horse.5c27854b.jpg";